import { useTranslation } from 'react-i18next';

import { FormField, IAutocompleteProps } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { corporateService } from 'corporate/services';
import { IFreightTerm } from 'corporate/types';

export const FreightTermFormField = (props: IAutocompleteProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <FormField
      name="freightTerm"
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        control,
        error: errors?.freightTerm,
        label: t('labelFreightTerm'),
        getOptions: corporateService.getFreightTerms,
        getLabel: (option: IFreightTerm) => option?.name,
        enabledOnFocus: false,
        ...props,
      }}
    />
  );
};
